/*
 * @Author: your name
 * @Date: 2021-03-08 17:26:36
 * @LastEditTime: 2021-12-04 16:59:42
 * @LastEditors: lks
 * @Description: In User Settings Edit
 */
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store/index';
import { homeRoutes } from './home';
import { questionRoute } from './questionnaire';
import { votingRoute } from './voting';
import { onlineRoute } from './onlineTest';
import { articleRoute } from './article';
import { templateRoute } from './template';
import { accountRoute } from './account';
import { togetherRoute } from './together';
import { memberRoute } from './member';
import { programmeRoute } from './programme';
import { activityCommonRoute } from './activityCommon';
import { taskRoute } from './task';
import { mutualRouter } from './mutual';
import { CollaborationCasesRoute } from './CollaborationCases';
import { merchantRoute } from './merchant';
import { emailRoute } from './email';
import { aiQuestionnaire } from './aiQuestionnaire';
import { getSubName } from '@/utils/getHost';
const favicon = getSubName() == 'longyixiu' ? '/favicon.ico' : getSubName() == 'wenjuanjia' ? '/favicon2.ico' : '/favicon.ico';
Vue.use(VueRouter);

const defaultRouter: RouteConfig[] = [
  // {
  //   path: '/',
  //   redirect: '/index',
  // },
  {
    path: '*',
    redirect: '/',
  },
];

const routes: RouteConfig[] = defaultRouter.concat(homeRoutes, questionRoute, votingRoute, onlineRoute, articleRoute, templateRoute, accountRoute, togetherRoute, memberRoute, programmeRoute, activityCommonRoute, taskRoute, mutualRouter, CollaborationCasesRoute, emailRoute, merchantRoute, aiQuestionnaire);

const router = new VueRouter({
  mode: 'history', // hash是访问带#号 history不带#号
  routes,
});

const whileRoutes = [
  '/',
  '/index',
  '/login',
  '/proList.html',
  '/help.html',
  '/template/list.html',
  '/template/detail.html',
  '/template/detailQuestion.html',
  '/account',
  // '/together/index.html',
  '/member/index.html',
  '/programme/index.html',
  '/index/vote',
  '/index/form',
  '/index/survey',
  '/index/exam',
  '/index/online',
  '/index/solitaire',
  '/index/order',
  '/auth',
  '/authH5',
  '/H5qyWechat',
  '/CollaborationCases/index.html',
  '/CollaborationCasesDetail/1',
  '/CollaborationCasesDetail/2',
  '/CollaborationCasesDetail/3',
  '/CollaborationCasesDetail/4',
  '/CollaborationCasesDetail/5',
  '/CollaborationCasesDetail/6',
  '/CollaborationCasesDetail/7',
  '/CollaborationCasesDetail/8',
  '/CollaborationCasesDetail/9',
  '/CollaborationCasesDetail/10',
  '/CollaborationCasesDetail/11',
  '/CollaborationCasesDetail/12',
  '/help/search.html',
];

/**
 * @description: 全局路由守卫
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
router.beforeEach((to, from, next) => {
  // 根据不同的域名显示不同的favicon
  const faviconLink = document.querySelector('link[rel="icon"]');
  console.log(faviconLink, 'faviconLink');
  if (faviconLink) {
    faviconLink.setAttribute('href', favicon);
  }
  if (to.meta) {
    store.dispatch('app/actionMenuName', to.meta.parentTab || '');
  }
  if (whileRoutes.includes(to.path) || to.name == 'x') {
    if (store.getters['user/isLogin']() && to.path === '/login') {
      // alert(1)
      next('/index');
    } else {
      // console.log(to, 'to')
      // alert(2)
      next();
    }
  } else {
    if (store.getters['user/isLogin']() && to.meta) {
      store.dispatch('app/actionMenuName', to.meta.parentTab || 'questionnaire');
      store.dispatch('app/actionMenuNameQuestionnaire', to.meta.parentTab || 'questionnaire');
      next();
    } else {
      // alert(4)
      // next('/login');
      next({
        name: 'loginIndex',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
});
// router.afterEach(() => {
//   window.scrollTo(0, 0);
//   // 或
//   // window.scroll(0, 0);
// });

// //获取原型对象上的push函数
// const originalPush = VueRouter.prototype.push
// //修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err: any) => err)
// }

export default router;
